import { message } from 'antd';
import { drawCrossHairInitial } from '../component/scanner/slot_component_utils';
import { get_response, post_response } from "../helper/request";
import { RegionSelectionConstants } from '../redux_constants/region_selection.constant';
import { ScanApiConstant } from '../redux_constants/scan.constant';
import { setDeviceBusy, setDeviceIdle } from './device_status.action';
import {openEndPoint} from "../utils/utils";
import {updateIsScanningStarted} from "./scanWorkflow.action";

export const initPreviewForScan = (slot, defaultConfig) => dispatch => {
    dispatch({
        type: ScanApiConstant.INIT_PREVIEW,
        slot: slot,
        defaultConfig: defaultConfig
    });
    return Promise.resolve();
}

export const fetchingPreview = (slot) => ({
    type: ScanApiConstant.TAKING_PREVIEW,
    slot: slot
})

export const receivedPreviewStatus = (type, response, slot) => ({
    type: type,
    response: response,
    slot: slot
})

export const setDoTilingOnly = (slot) => ({
    type: ScanApiConstant.SET_DO_TILING_ONLY, 
    slot: slot
})

export const setDoTilingAfterScan = (slot) => ({
    type: ScanApiConstant.SET_DO_TILING_AFTER_SCAN, 
    slot: slot
})

export const unsetDoTilingOnly = (slot) => ({
    type: ScanApiConstant.UNSET_DO_TILING_ONLY, 
    slot: slot
})

export const unsetDoTilingAfterScan = (slot) => ({
	type: ScanApiConstant.UNSET_DO_TILING_AFTER_SCAN,
	slot: slot
})

export const setSpecimenType = (slot, specimenType) => ({
	type: ScanApiConstant.SPECIMEN_TYPE_CHANGE,
	specimenType: specimenType,
	slot: slot
})

export const setSpecimenTypeForAllSlots = (specimenType) => ({
	type: ScanApiConstant.SPECIMEN_TYPE_CHANGE_FOR_ALL_SLOTS,
	specimenType: specimenType
})

export const setObjectiveType = (slot, objectiveType) => ({
	type: ScanApiConstant.OBJECTIVE_TYPE_CHANGE,
	objectiveType: objectiveType,
	slot: slot
})

export const setScanOutputFormat = (slot, scanOutputFormat) => ({
	type: ScanApiConstant.SCAN_OUTPUT_FORMAT_CHANGE,
	scanOutputFormat: scanOutputFormat,
    slot: slot
})

export const selectionDone = (slot) => ({
    type: ScanApiConstant.REGION_SELECTION_DONE, 
    slot:slot
})

export const selectionCancelled = (slot) => ({
    type: ScanApiConstant.SELECTION_CANCELLED, 
    slot:slot
})

export const setPreviewStatusToConfirmed = (slot, region, actualRegion) => ({
    type: ScanApiConstant.SELECTION_CONFIRMED, 
    slot: slot, 
    region: region, 
    actualRegion: actualRegion
})

export const setScanSpeed = (slot, speed) => ({
    type: ScanApiConstant.SPEED_CHANGE, 
    slot: slot,
    speed: speed
})

export const setScanProfile = (slot, profile) => ({
    type: ScanApiConstant.PROFILE_CHANGE, 
    slot: slot,
    profile: profile
})

export const setScanZLevels = (slot, value) => ({
    type: ScanApiConstant.Z_STACK_LEVELS_CHANGE, 
    slot: slot,
    value: value
})

export const setAutoThreshLevel = (slot, value) => ({
    type: ScanApiConstant.AUTO_THRESH_LEVEL_CHANGE,
    slot: slot,
    value: value
})

export const setScanZStepSize = (slot, value) => ({
    type: ScanApiConstant.STEP_SIZE_CHANGE, 
    slot: slot,
    value: value
})

export const setScanSpeedForAllSlots = (speed) => ({
    type: ScanApiConstant.SPEED_CHANGE_FOR_ALL_SLOTS, 
    speed: speed
})

export const setScanSpeedForTray = (tray, speed) => ({
    type: ScanApiConstant.SPEED_CHANGE_FOR_TRAY, 
    tray: tray,
    speed: speed
})

export const setSpecimenTypeForTray = (tray, specimenType) => ({
    type: ScanApiConstant.SPECIMEN_CHANGE_FOR_TRAY, 
    tray: tray,
    specimenType: specimenType,
})

export const setObjectiveTypeForTray = (tray, objectiveType) => ({
    type: ScanApiConstant.OBJECTIVE_CHANGE_FOR_TRAY, 
    tray: tray,
    objectiveType: objectiveType,
})

export const setScanName = (slot, name) => ({
    type: ScanApiConstant.NAME_CHANGE, 
    slot: slot,
    name: name
})

export const setFolderName = (slot, name) => ({
    type: ScanApiConstant.FOLDER_NAME_CHANGE,
    slot: slot,
    name: name
})

export const setDropDistancePoint = (slot, dropDistancePoint) => ({
    type: ScanApiConstant.UPDATE_DROP_DISTANCE_POINT, 
    slot: slot,
    dropDistancePoint: dropDistancePoint
})

export const setDropDistancePointOnly = (slot, dropDistancePoint) => ({
    type: ScanApiConstant.UPDATE_DROP_DISTANCE_POINT_ONLY, 
    slot: slot,
    dropDistancePoint: dropDistancePoint
})

export const setDropDistancePointLength = (slot, dropDistancePoint) => ({
    type: ScanApiConstant.UPDATE_DROP_DISTANCE_POINT_LENGTH, 
    slot: slot,
    dropDistancePoint: dropDistancePoint
})

export const setFocusPoints = (slot, focusPoints) => ({
    type: ScanApiConstant.UPDATE_FOCUS_POINTS, 
    slot: slot,
    focusPoints: focusPoints
})

export const updatePreviewStatus = (slot, status) => ({
    type: ScanApiConstant.UPDATE_STATUS, 
    slot: slot,
    status: status
})

export const updateActionOngoing = (slot, status, message) => ({
    type: ScanApiConstant.UPDATE_ACTION_ONGOING, 
    slot: slot,
    actionOngoing: status,
    message: message
})

export const updateCanvasSize = (slot, size) => ({
    type: ScanApiConstant.UPDATE_CANVAS_SIZE, 
    slot: slot,
    size: size
})

export const changeSpecimenType = (id, slot, specimenType) =>(dispatch)=>{
    let url = `/server/devices/` + id + "/set_specimen_type/?slotID=" + slot + "&specimenType=" + specimenType
    get_response(url).then(response => {
        if (response.status === 200) {
            dispatch(setSpecimenType(slot, specimenType))
        }
    })
    .catch(err => {
        console.log(err);
    })
}

export const changeScanSpeed = (id, slot, scanSpeed) =>(dispatch)=>{
    let url = `/server/devices/` + id + "/set_scan_speed/?slotID=" + slot + "&scanSpeed=" + scanSpeed
    get_response(url).then(response => {
        if (response.status === 200) {
            dispatch(setScanSpeed(slot, scanSpeed))
        }
    })
    .catch(err => {
        console.log(err);
    })
}

export const changeSlideName = (id, slot, slideName) =>(dispatch)=>{
    console.log("slidenam2",slideName)
    let url = `/server/devices/` + id + "/set_slide_name_v2/?slotID=" + slot + "&rack=null&tray=null&slideName=" + slideName
    get_response(url).then(response => {
        if (response.status === 200) {
            dispatch(setScanName(slot, slideName))
        }
    })
    .catch(err => {
        console.log(err);
    })
}
export const takePreviewBlood = (id, slot) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Taking Preview"));
    dispatch(fetchingPreview(slot));
    let url = `/server/devices/` + id + `/take_preview_background/?slot_id=${slot}&blood=${true}`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                // dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, JSON.parse(response.data), slot))
                dispatch(setDeviceIdle(id));
            }
            else {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, response, slot))
                dispatch(setDeviceIdle(id));
            }
        })
        .catch(err => {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, err, slot))
            dispatch(setDeviceIdle(id));
            console.log(err)
        })
}

export const takePreview = (id, slot) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Taking Preview"));
    dispatch(fetchingPreview(slot));
    let url = `/server/devices/` + id + "/take_preview_background/?slot_id=" + slot;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                // dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, JSON.parse(response.data), slot))
                dispatch(setDeviceIdle(id));
                // dispatch(updatePreviewStatus(slot, RegionSelectionConstants.CONFIRMED))
            }
            else {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, response, slot))
                dispatch(setDeviceIdle(id));
            }
        })
        .catch(err => {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, err, slot))
            dispatch(setDeviceIdle(id));
            console.log(err)
        })
}

export const takePreviewBma = (id, slot) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Taking Preview"));
    dispatch(fetchingPreview(slot));
    let url = `/server/devices/` + id + `/take_preview_background/?slot_id=${slot}&bma=${true}`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                // dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, JSON.parse(response.data), slot))
                dispatch(setDeviceIdle(id));
                // dispatch(updatePreviewStatus(slot, RegionSelectionConstants.CONFIRMED))
            }
            else {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, response, slot))
                dispatch(setDeviceIdle(id));
            }
        })
        .catch(err => {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, err, slot))
            dispatch(setDeviceIdle(id));
            console.log(err)
        })
}

export const saveSelectedPreviewsForTuning = (device_id, selectedSlots) => (dispatch) => {
    dispatch(setDeviceBusy(device_id, "Saving Preview for Tuning"));
    let url = `/server/devices/` + device_id + "/save_previews_for_tuning/?data=" + selectedSlots;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                message.success("Saved Preview(s) for Tuning");
                dispatch(setDeviceIdle(device_id));
            }
            else {
                message.success("Failed to Save Preview(s) for Tuning");
                console.error("didn't get 200 status code", response);
                dispatch(setDeviceIdle(device_id));
            }
        })
        .catch(err => {
            message.success("Failed to Save Preview(s) for Tuning");
            dispatch(setDeviceIdle(device_id));
            console.error("error while saving preview for tuning", err);
        })
}

export const takeSelectedPreview = (id, selectedSlots, callback, blood=false, isBarcodeRead= true, isBarcodeReadOcr= true) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Taking Preview"));
    selectedSlots.map(slot => {
        dispatch(fetchingPreview(slot));
    })
    let url;
    if (blood) {
        url = `/server/devices/` + id + "/take_all_previews/?data=" + selectedSlots+"&blood=true";
    } else {
        url = `/server/devices/` + id + "/take_all_previews/?data=" + selectedSlots+"&isBarcodeRead=" + isBarcodeRead + "&isBarcodeReadOcr=" + isBarcodeReadOcr;
    }
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                // selectedSlots.map((slot, index) => {
                //     dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, JSON.parse(response.data)[index], slot))
                // });
                dispatch(setDeviceIdle(id));
            }
            else {
                selectedSlots.map((slot) => {
                    dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, response, slot))
                });
                dispatch(setDeviceIdle(id));
            }
        })
        .catch(err => {
            selectedSlots.map((slot) => {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, err, slot))
            });
            dispatch(setDeviceIdle(id));
            console.log(err)
        })
}

export const takeAllPreviews = (id, cassetteSize, setShowSummary, selectedSlots, isBarcodeRead= true, isBarcodeReadOcr= true) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Taking Preview"));
    for (var i = 0; i < cassetteSize; i++) {
        dispatch(fetchingPreview(i));
    }
    let url = `/server/devices/` + id + "/take_all_previews/?data=" + selectedSlots+"&isBarcodeRead=" + isBarcodeRead + "&isBarcodeReadOcr=" + isBarcodeReadOcr;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                let previewResponses = JSON.parse(response.data);
                for (var i = 0; i < cassetteSize; i++) {
                    let previewResponse = previewResponses[i];
                    let reg = {
                        data: { index: 0 },
                        height: 100,
                        isChanging: false,
                        new: false,
                        width: 100,
                        x: 0,
                        y: 0,
                    }
                    let x1 = parseInt((reg.x * previewResponse.previewWidth) / 100.0);
                    let x2 = parseInt(((reg.x + reg.width) * previewResponse.previewWidth) / 100.0);
                    let y1 = parseInt((reg.y * previewResponse.previewHeight) / 100.0);
                    let y2 = parseInt(((reg.y + reg.height) * previewResponse.previewHeight) / 100.0);
                    let actualReg = [x1, y1, x2, y2];
                    dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, previewResponse, i));
                    dispatch(setPreviewStatusToConfirmed(i, reg, actualReg));
                }
                dispatch(setDeviceIdle(id));
                setShowSummary();
            }
            else {
                for (var i = 0; i < cassetteSize; i++) {
                    dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, response, i));
                }
                dispatch(setDeviceIdle(id));
            }
        })
        .catch(err => {
            for (var i = 0; i < cassetteSize; i++) {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, err, i));
            }
            dispatch(setDeviceIdle(id));
            console.log(err)
        })
}

export const selectionConfirmed = (id, slot, regionInCanvas, actualRegion, image, name, startScanCallback, cassetteSize, specimenType, 
    objectiveType, preview, dropDistanceCanvas,greenBoxRegion) => (dispatch) => {
    dispatch(setDeviceBusy(id));
    const url = '/server/devices/' + id + "/send_threshold_image/?slot_id=" + slot;
    const data = {
        imgBase64: image, 
        specimenType: specimenType,
        objectiveType: objectiveType,
        actualRegion: actualRegion,
        previewData: preview,
        greenBoxRegion: greenBoxRegion,
    }
    post_response(url, data)
    .then(response => {
        if (response.status === 200) {
            dispatch(setPreviewStatusToConfirmed(slot, regionInCanvas, actualRegion));
            dispatch(setDropDistancePoint(slot, response.data.dropDistancePoint));
            dispatch(setFocusPoints(slot, response.data.focusPoints));
            dispatch(setDeviceIdle(id));
            // if (cassetteSize === 1) {
            //     startScanCallback();
            // }
        }
        else {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, slot))
            dispatch(setDeviceIdle(id));
        }
    })
    .catch(err => {
        dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, slot))
        dispatch(setDeviceIdle(id));
    })
}

export const dropDistanceConfirmed = (id, slot, preview, focusPointsCanvas) => dispatch => {
    dispatch(setDeviceBusy(id));
    const url = '/server/devices/' + id + "/set_drop_distance_point/?slot_id=" + slot;
    post_response(url, {points: preview.dropDistancePoint})
    .then(response => {
        if (response.status === 200) {
            dispatch(updatePreviewStatus(slot, RegionSelectionConstants.START_FOCUS_POINTS_SELECTION));
            dispatch(setDeviceIdle(id));
        }
        else {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, slot))
            dispatch(setDeviceIdle(id));
        }
    })
    .catch(err => {
        dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, slot))
        dispatch(setDeviceIdle(id));
    })
}

export const onDeleteFocusPoint = (id, slot, preview, focusPointsCanvas, islandID, index) => dispatch => {
    dispatch(setDeviceBusy(id));

    let partsOfUrl = "api~scan~delete_focus_point/";
    let url = `/server/scano/` + id + `/` + partsOfUrl + "/?slot_id=" + slot + "&island_id=" + islandID + "&index=" + index;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                //Plot focus points on canvas
                let pointDrawn = false;
                for (let island in response.data.focusPoints) {
                    for (let i = 0; i < response.data.focusPoints[island].length; i++) {
                        let focusUnit = response.data.focusPoints[island][i];
                        if (focusUnit.length > 0) {
                            drawCrossHairInitial(focusUnit[0].x, focusUnit[0].y, focusPointsCanvas,
                                {clearCanvas: !pointDrawn, color: 'green', size: 5, width: 1}, preview);
                            pointDrawn = true;
                        }
                    }
                }
                if (!pointDrawn) {
                    let canvasContext = focusPointsCanvas.getContext("2d");
                    canvasContext.clearRect(0, 0, focusPointsCanvas.width, focusPointsCanvas.height);
                }
                dispatch(setFocusPoints(slot, response.data.focusPoints));
            }
            else {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, slot))
            }
            dispatch(setDeviceIdle(id));
        })
        .catch(err => {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, slot))
            dispatch(setDeviceIdle(id));
        })
}

export const onAddFocusPoint = (event, id, slot, preview, focusPointsCanvas) => dispatch => {
    let rect = focusPointsCanvas.getBoundingClientRect();
    let canvasx = rect.x;
    let canvasy = rect.y;
    let mousex = parseInt(((event.pageX - canvasx) / rect.width) * focusPointsCanvas.width);
    let mousey = parseInt(((event.pageY - canvasy) / rect.height) * focusPointsCanvas.height);
    let x = mousex;
    let y = mousey;

    if (x===0 && y===0){
        return;
    }

    x = x-window.scrollX;
    y = y-window.scrollY;

    let realX = Math.trunc(x * (preview.response.previewWidth / focusPointsCanvas.width));
    let realY = Math.trunc(y * (preview.response.previewHeight / focusPointsCanvas.height));

    dispatch(setDeviceBusy(id));

    let partsOfUrl = "api~scan~add_focus_point/";
    let url = `/server/scano/` + id + `/` + partsOfUrl + "/?slot_id=" + slot + "&x=" + realX + "&y=" + realY;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                //Plot focus points on canvas
                let pointDrawn = false;
                for (let island in response.data.focusPoints) {
                    for (let i = 0; i < response.data.focusPoints[island].length; i++) {
                        let focusUnit = response.data.focusPoints[island][i];
                        if (focusUnit.length > 0) {
                            drawCrossHairInitial(focusUnit[0].x, focusUnit[0].y, focusPointsCanvas,
                                {clearCanvas: !pointDrawn, color: 'green', size: 5, width: 1}, preview);
                            pointDrawn = true;
                        }
                    }
                }
                dispatch(setFocusPoints(slot, response.data.focusPoints));
            }
            else {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, slot))
            }
            dispatch(setDeviceIdle(id));
        })
        .catch(err => {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, slot))
            dispatch(setDeviceIdle(id));
        })
}

export const startScanning = (id, previewData, bloodConfig, isBlood_) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Initialising"));
    dispatch(updateIsScanningStarted(false))
    let typeBlood = false;
    if(isBlood_!= undefined && isBlood_) typeBlood = true;
    const url = '/server/devices/' + id + '/start_scan/';
    const data = {
        previewData: previewData,
        bloodConfig: bloodConfig == null ? null: bloodConfig.countWBCSlotWise,
        isBlood: typeBlood
    }
    post_response(url, data)
    .then(response => {
        if (response.status === 200) {
            dispatch(updateIsScanningStarted(true))
            message.success("Started Scans");
            dispatch(setDeviceIdle(id));
        }
        else {
            message.error("Could not start scans. Please contact administrator.")
            dispatch(setDeviceIdle(id));
        }
    })
    .catch(err => {
        message.error("Could not start scans. Please contact administrator.")
        dispatch(setDeviceIdle(id));
    })
}

export const cancelScanning = (id, loaderPresent) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Cancelling"));
    let url = loaderPresent ? '/server/devices/' + id + '/cancel_loader/' : '/server/devices/' + id + '/cancel/';
    get_response(url)
    .then(response => {
        if (response.status === 200) {
            message.success("Cancelled Scanning");
            dispatch(setDeviceIdle(id));
            openEndPoint('/scanners/' + id, false, true);
        }
        else {
            message.error("Could not cancel scanning. Please contact Morphle Support.")
            dispatch(setDeviceIdle(id));
        }
    })
    .catch(err => {
        message.error("Could not cancel scanning. Please contact Morphle Support.")
        dispatch(setDeviceIdle(id));
    })
}

export const cancelPreview = (id, loaderPresent) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Cancelling Preview"));
    let url = loaderPresent ? '/server/devices/' + id + '/c240/cancel_preview/' : '/server/devices/' + id + '/cancel_preview/';
    get_response(url)
    .then(response => {
        if (response.status === 200) {
            message.success("Cancelled Preview");
            dispatch(setDeviceIdle(id));
        }
        else {
            message.error("Error. Could not cancel preview. Please contact administrator.")
            dispatch(setDeviceIdle(id));
        }
    })
    .catch(err => {
        message.error("Could not cancel preview. Please contact administrator.")
        dispatch(setDeviceIdle(id));
    })
}

export const getDefaultConfig = (deviceId, slotId) => (dispatch) => {
    dispatch(setDeviceBusy(deviceId, "Setting Up"));
    const url = "/server/devices/" + deviceId + "/settings/get_scanner_properties/";
    get_response(url)
    .then(res => {
        dispatch(initPreviewForScan(slotId, res.data.defaultConfig));
        dispatch(setDeviceIdle(slotId));
    })
    .catch(err => {
        console.log(err);   
        dispatch(setDeviceIdle(deviceId));
    });
}

export let updateSlideName = (slideName, rack, tray, id, deviceId) => (dispatch) => {
    dispatch(setScanName(id, slideName));
    let folderNameSplit = slideName.split("-")
    let folderName = folderNameSplit[0];
    if (folderNameSplit.length > 1) {
        folderName = folderNameSplit[0] + "-" + folderNameSplit[1];
    }
    const url = `/server/devices/${deviceId}/set_slide_name_v2/?slotID=${id}&rack=${rack}&tray=${tray}&slideName=${slideName}`;
    get_response(url).then(res => {
        console.log("name updated");
        dispatch(updateFolderName(folderName, rack, tray, id, deviceId));
    }).catch(err => {
        message.warn("Failed to update name, please retry");
        console.error(err);
    })
}

export let updateFolderName = (folderName, rack, tray, id, deviceId) => (dispatch) => {
    dispatch(setFolderName(id, folderName));
    if (folderName === undefined || folderName === "undefined") {
        folderName = "";
    }
    const url = `/server/devices/${deviceId}/set_folder_name_v2/?slotID=${id}&rack=${rack}&tray=${tray}&folderName=${folderName}`;
    get_response(url).then(res => {
        console.log("folder name updated")
    }).catch(err => {
        message.warn("Failed to update folder name, please retry");
        console.error(err);
    })
}
